export default class ForgotPasswordRequest {
    email: string;
    institutionId: string;
}